import type { PointArray } from '../types/contour-definition-array-type';

import { difference, featureCollection } from '@turf/turf';

import { convertArrayToPointArray } from './convertArrayToPointArray';
import { getSimpleArrayArea } from './getSimpleArrayArea';
import { pointArrayToPolygon } from './turf-utils';

/**
 *
 * @param pointArray1
 * @param pointArray2
 * @returns Returns the difference of two arrays. Polygon1 excluding the area of Polygon2. If multiple differences exist, returns the biggest.
 */
export function getPolygonDifference(
  pointArray1: PointArray,
  pointArray2: PointArray,
): PointArray {
  // ToDO: What if second polygon is completly inside the first one?
  const polygon1 = pointArrayToPolygon(pointArray1);
  const polygon2 = pointArrayToPolygon(pointArray2);

  const differencePolygon = difference(featureCollection([polygon1, polygon2]));

  // If the type of intersectPolygon.geometry is MultiPolygon that means
  // the input polygons intersect multiple times
  if (differencePolygon) {
    if (differencePolygon.geometry.type === 'Polygon') {
      return convertArrayToPointArray(
        differencePolygon.geometry.coordinates[0],
      );
    }
    if (differencePolygon.geometry.type === 'MultiPolygon') {
      const sortedAreas = differencePolygon.geometry.coordinates.sort(
        (a, b) => getSimpleArrayArea(b[0]) - getSimpleArrayArea(a[0]),
      );
      const biggestArea = sortedAreas[0][0];
      return convertArrayToPointArray(biggestArea);
    }
  }

  return [];
}
